import React from "react";
import styled from "styled-components";
import { MediaItem, MediaType } from "@mindmemobile/mm-shared-library";
import { observer } from "mobx-react";
import SharedLibrary from "./SharedLibrary";
import { MediaModel } from "../models/GalleryModels";
import {
  AuthService,
  FlexContainer,
  ModalComponent,
} from "@mindmemobile/mm-shared-global";

type IProps = {
  hideLabel?: boolean;
  allowedMediaTypes?: (keyof typeof MediaType)[];
  medias?: MediaModel[];
  onUpload?: (medias: MediaModel[]) => void;
  onDelete?: (media: MediaModel) => void;
  multiple?: boolean;
  onSelectLibraryMedia: (media: MediaItem) => void;
  onFavourite?: (media: MediaModel) => void;
  showUploadButtons?: boolean;
  hideOverlays?: boolean;
  allowOnlyOne?: boolean;
  toggleLibrary?: (show: boolean, fromUpload?: boolean) => void;
  showLibrary?: boolean;
  updateMedia?: (medias: MediaModel[]) => void;
  showUpload?: boolean;
};

const FullLibraryView: React.FC<IProps> = (props) => {
  return (
    <FullViewPopupLibraryContainer>
      <ModalComponent
        title="Upload Media"
        titleFontSize="22px"
        showFooter={false}
        minHeight="440px"
        bodyBackgroundColor="#fefefe"
        footerBackground="#F4F7FB"
        footerHeight="auto"
        onClose={() => props.toggleLibrary?.(false)}
        footerContent={null}
        // wrapperWidth="calc(100% - 100px)" //unsplash and pixabay needs atleast this to get 5 in a row
        wrapperWidth="calc(100% - 60px)" // sunil asked to change the width as main system
        // wrapperWidth="1150px"
        maxHeight="144px"
        // bodyHeight="800px"
      >
        <SharedLibrary
          onMediaItemClick={(media) => props.onSelectLibraryMedia(media)}
          userId={AuthService.mindmeAccountDetails?.userId || ""}
          subAccountId={AuthService.mindmeAccountDetails?.subAccountId || ""}
          parentAccountId={AuthService.mindmeAccountDetails?.parentAccountId || ""}
          bearerToken={""}
          showUpload={false}
          allowedMediaTypes={["Image"]}
          apiBaseURL={process.env.REACT_APP_MINDME_MAIN_API || ""}
        />
      </ModalComponent>
    </FullViewPopupLibraryContainer>
  );
};

export default observer(FullLibraryView);

// Styled components
export const FullViewPopupLibraryContainer = styled.div`
  width: 100%;
  height: 100%;

  .library-content {
    > div:last-child {
      max-height: 460px;
      @media (min-width: 2400px) {
        max-height: calc(100vh - 270px) !important;
      }
      @media (max-width: 2200px) {
        max-height: 668px;
      }
      @media (max-width: 1920px) {
        max-height: 564px;
      }
      @media (max-width: 1900px) {
        max-height: 479px;
      }
      @media (max-width: 1600px) {
        max-height: 375px;
      }
      @media (max-width: 1360px) {
        max-height: 315px;
      }

      @media (max-width: 900px) {
        max-height: 300px;
      }
    }
  }
`;
